export default __webpack_public_path__ + "static/media/goya-products.1fa25a45.jpg";